import { render, staticRenderFns } from "./Project-Page.vue?vue&type=template&id=ca4df6b6&"
import script from "./Project-Page.vue?vue&type=script&lang=js&"
export * from "./Project-Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports